var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38393 1.42857C0 2.8125 0 5.08929 0 9.64286V10.4018C0 14.9554 0 17.2321 1.38393 18.6161C2.76786 20 5.04464 20 9.59821 20H10.3571C14.9107 20 17.1875 20 18.5714 18.6161C20 17.2321 20 14.9554 20 10.4018V9.64286C20 5.08929 20 2.8125 18.5714 1.42857C17.1875 0 14.9107 0 10.3571 0H9.59821C5.04464 0 2.76786 0 1.38393 1.42857ZM3.34821 6.11607H5.625C5.71429 9.91071 7.41071 11.5179 8.75 11.875V6.11607H10.8929V9.375C12.1875 9.24107 13.5714 7.76786 14.0625 6.11607H16.2054C16.0268 6.96429 15.6696 7.76786 15.1786 8.48214C14.6429 9.19643 14.0179 9.82143 13.2589 10.2679C14.1071 10.6696 14.8214 11.25 15.4464 11.9643C16.0268 12.6786 16.4732 13.5268 16.6964 14.4196H14.3304C14.1071 13.6607 13.6607 12.9464 13.0357 12.4107C12.4554 11.875 11.6964 11.5625 10.8929 11.4732V14.4196H10.625C6.07143 14.4196 3.48214 11.2946 3.34821 6.11607Z",
    fill: "#002E33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.d601e259ddb4815381276cd3fc6bc50a.svg";
export { ForwardRef as ReactComponent };